import { User } from './user';

export interface Account {
  id?: number;
  status: string;
  statusCode: string;
  accountCode: string;
  isValid: boolean;
  user: User;
}
